import React from 'react';
import { Cell } from '../components/Cell';
import { LoadingCellContent } from '../components/LoadingCellContent';
/**
 * Default renderer for loading cells
 * @param row
 * @param column
 * @returns
 */
export function renderLoadingCell(row, column) {
    if (column.hidden === true) {
        return null;
    }
    const cellProps = {
        align: column.align,
        key: `${row.id}-${column.id}`,
        role: 'cell',
        spacing: column.spacing,
    };
    return (React.createElement(Cell, Object.assign({}, cellProps),
        React.createElement(LoadingCellContent, null)));
}
//# sourceMappingURL=renderLoadingCell.js.map